import ParityFilterInput from '@app/model/parity/input/ParityFilterInput';

export const ParityQueryKeys = {
	all: ['parity'] as const,
	periods: (companyHotelId: number, startStatDate: string, endStatDate: string, filterInput: ParityFilterInput) => [...ParityQueryKeys.all, 'period', companyHotelId, startStatDate, endStatDate, filterInput] as const,
	ota_periods: (companyHotelId: number, startStatDate: string, endStatDate: string, filterInput: ParityFilterInput) => [...ParityQueryKeys.all, 'ota_periods', companyHotelId, startStatDate, endStatDate, filterInput] as const,
};